import { IForm } from '@/components/types'
export const modalConfig: IForm = {
  formItems: [
    {
      field: 'stockName',
      type: 'input',
      label: '股票名称',
      placeholder: '请输入股票名称',
      rules: { required: true, message: '股票名称是必传的', trigger: 'blur' }
    },
    {
      field: 'stockCode',
      type: 'input',
      label: '股票代码',
      placeholder: '请输入股票代码',
      rules: { required: true, message: '股票代码是必传的', trigger: 'blur' }
    },
    {
      field: 'stockTag',
      type: 'input',
      label: '概念名称',
      placeholder: '请输入概念名称',
      rules: { required: true, message: '概念名称是必传的', trigger: 'blur' }
    },
    {
      field: 'plateName',
      type: 'input',
      label: '板块名称',
      placeholder: '请输入板块名称',
      rules: { required: true, message: '板块名称是必传的', trigger: 'blur' }
    },
    {
      field: 'logic',
      type: 'input',
      label: '逻辑',
      placeholder: '请输入逻辑',
    },
  ],
  colLayout: 24,
  itemStyle: {}
}
